import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { withRouter } from "react-router-dom";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {}

class FooterComponent extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        {!this.props.Store.Ui.Footer.display ? (
          <></>
        ) : (
          <footer className="footer">
            <div className="cont">
              <div className="footer__top">
                <div className="footer__logo-block">
                  <div className="footer__logo-and-telegram">
                    <a
                      className="footer__logo"
                      href="https://profi.travel/"
                      target="_blank"
                    >
                      <img
                        alt="Profi.Travel"
                        src={require("@public/images/logo-pt.svg")}
                      />
                    </a>
                  </div>
                </div>

                <a
                  className="footer__text underline hover:no-underline"
                  href="https://profi.travel/legal"
                  target="_blanc"
                >
                  Пользовательское соглашение
                </a>

                <a
                  className="footer__text underline hover:no-underline"
                  href="https://profi.travel/uploads/docs/company_policies_of_personal_data_processing_ru.pdf"
                  target="_blanc"
                >
                  Обработка персональных данных
                </a>

                {/* <a href="https://t.me/otm_tourism" target="_blank">
                  <img
                    alt="Telegram"
                    src={require("@public/images/icon-telegram-grey.svg")}
                  />
                </a> */}
                {/* <div className="footer__text">
                  ООО «Профи.Трэвел»
                  <br />
                  ИНН 6685014210
                </div> */}
              </div>
              <div className="footer__content">
                <div className="footer__item footer__hr">
                  <div className="footer__item-title">
                    Для клиентов и партнёров
                  </div>
                  <div className="footer__item-descr">
                    <div className="footer__item-undertitle">
                      Стать экспонентом
                    </div>
                    <a
                      href="https://welcome.profi.travel/onlinefairs"
                      target="_blank"
                    >
                      Подробнее о выставке
                    </a>
                    <a href="mailto:welcome@profi.travel">
                      welcome@profi.travel
                    </a>
                    <a href="tel:+79310096994" className="footer__item-name">
                      +7 (931) 009 69 94
                    </a>
                    <div>
                      <a
                        href="https://t.me/Profitravel_official"
                        target="_blank"
                        className="footer__item-loyalty"
                      >
                        <span className="footer__item-loyalty-tg"></span>
                      </a>
                      <a
                        href="https://wa.me/79310096994"
                        target="_blank"
                        className="footer__item-loyalty"
                      >
                        <span className="footer__item-loyalty-whatsapp"></span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="footer__item">
                  <div className="footer__item-title">
                    Для посетителей выставки
                  </div>
                  <div className="footer__item-descr">
                    <div className="footer__item-subtitle">
                      Руководитель выставки
                    </div>
                    <p className="footer__item-name">Ирина Васильева</p>
                    <a href="mailto:vasilyeva.i@profi.travel">
                      vasilyeva.i@profi.travel
                    </a>
                  </div>

                  <div className="footer__item-descr">
                    <div className="footer__item-subtitle">
                      Техническая поддержка
                    </div>
                    <div className="footer__item-undertitle">
                      ошибки сайта, вход, трансляции
                    </div>
                    <div className="footer__item-descr">
                      <a href="mailto:academy@profi.travel">
                        academy@profi.travel
                      </a>
                      <p className="md:text-[14px]">
                        или чат с оператором <br /> в правом углу экрана
                      </p>
                    </div>{" "}
                  </div>
                  {/* <a
                href="https://welcome.profi.travel/#form"
                target="_blank"
                className="footer__item-contact-us"
              >
                Связаться
              </a> */}

                  <div className="footer__item-descr">
                    <div className="footer__item-subtitle">Loyalty</div>
                    <p className="footer__item-name">Сергей Перемутов</p>
                    <a
                      href="https://t.me/joinchat/R2ZetIMuTgIwODVi"
                      target="_blank"
                      className="footer__item-loyalty"
                    >
                      <span className="footer__item-loyalty-tg"></span>
                      Чат поддержки Loyalty
                    </a>
                  </div>
                </div>

                {/* <div className="footer__item footer__item--long">
                  <p className="footer__item-title">
                    Техническая поддержка
                    <br />
                    (вопросы о качестве трансляции)
                  </p>
                  <a href="mailto:academy@profi.travel">academy@profi.travel</a>
                  <br />
                  <a href="tel:+74997050825">
                    +7 (499) 705-08-25{" "}
                    <span className="text-green-footer">(доб.&nbsp;170)</span>
                  </a>
                </div> */}
                {/* <div className="footer__item">
                  <p className="footer__item-title">
                    По вопросам начисления&nbsp;баллов <span>Loyalty</span>
                  </p>
                  <p className="footer__item-name">Сергей Перемутов</p>
                  <a
                    href="https://t.me/joinchat/R2ZetIMuTgIwODVi"
                    target="_blank"
                    className="footer__item-loyalty"
                  >
                    Чат поддержки Loyalty
                    <span className="footer__item-loyalty-tg" />
                  </a>
                </div> */}

                <div className="footer__item">
                  <div className="footer__item-title">OTM в соцсетях</div>

                  <div className="footer__item-descr">
                    <a
                      href="https://t.me/otm_tourism"
                      target="_blank"
                      className="footer__item-loyalty"
                    >
                      <span className="footer__item-loyalty-tg"></span>
                      Расписание вебинаров по выездному туризму
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(FooterComponent)
);
